'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
require('./Radio.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Radio = function (props) {
    var id = props.id, labelName = props.labelName, className = props.className, value = props.value, isChecked = props.isChecked, handleOnChange = props.handleOnChange, name = props.name, isDisabled = props.isDisabled, hideLabel = props.hideLabel;
    var handleChange = function (event) {
        event.persist();
        handleOnChange(event, name, event.target.value);
    };
    return (React__default['default'].createElement("label", { className: "lp-radio__wrapper" },
        React__default['default'].createElement("input", { id: id, className: index['default']('lp__radio', className), type: "radio", checked: isChecked, onChange: handleChange, name: name, disabled: isDisabled, value: value }),
        !hideLabel && labelName));
};

exports.Radio = Radio;
//# sourceMappingURL=Radio.js.map
